export default __webpack_public_path__ + "static/media/emptyAlert.6d58c363.svg";